import React from "react"
import autobind from "class-autobind"
import { Dialog, FlatButton, Tabs, Tab } from "material-ui"
import strings from "../../../../../localization/strings"
import Clear from "../../../../misc/Clear"
import { IScheduleTemplate, IScheduleDocument } from "../../../../../models"
import SelectTemplateTable from "./SelectTemplateTable"
export enum ETemplateType {
  ScheduleTemplate,
  MasterSchedule
}
interface IProps {
  overrideHierarchy: boolean
  hierarchyId: string
  jobId: string
  handleClose(): void
  handleSelectTemplate(selectedTemplate: IScheduleTemplate | IScheduleDocument): void
}
interface IState {
  selectedTemplate: IScheduleTemplate | IScheduleDocument
}

export default class AddTemplateDialogForChip extends React.Component<IProps, IState> {
  constructor(props) {
    super(props)
    this.state = {
      selectedTemplate: null
    }
    autobind(this)
  }

  render() {
    return (
      <Dialog
        open
        modal
        title={strings.Select_Template}
        contentStyle={{ maxWidth: 500 }}
        bodyStyle={{ padding: 2 }}
        actions={[
          <FlatButton
            data-intercom-target={"AddTemplate-Btn-CloseAddTemplateDialog"}
            label={strings.Cancel}
            secondary
            onClick={this.props.handleClose}
          />,
          <FlatButton
            data-intercom-target={"AddTemplate-Btn-AddTemplate"}
            label={strings.OK}
            primary
            keyboardFocused
            disabled={!this.state.selectedTemplate}
            onClick={() => this.props.handleSelectTemplate(this.state.selectedTemplate)}
          />
        ]}
        onRequestClose={this.props.handleClose}
      >
        <Clear />
        <Tabs onChange={() => this.setState({ selectedTemplate: null })}>
          <Tab label={strings.Schedule_Templates} >
            <SelectTemplateTable
              templateType={ETemplateType.ScheduleTemplate}
              overrideHierarchy={this.props.overrideHierarchy}
              hierarchyId={this.props.hierarchyId}
              jobId={this.props.jobId}
              selectedTemplate={this.state.selectedTemplate}
              handleSelectTemplate={selectedTemplate => this.setState({ selectedTemplate })}
            />
          </Tab>
          <Tab label={strings.Master_Schedules} >
            <SelectTemplateTable
              templateType={ETemplateType.MasterSchedule}
              overrideHierarchy={this.props.overrideHierarchy}
              hierarchyId={this.props.hierarchyId}
              jobId={this.props.jobId}
              selectedTemplate={this.state.selectedTemplate}
              handleSelectTemplate={selectedTemplate => this.setState({ selectedTemplate })}
            />
          </Tab>
        </Tabs>
      </Dialog >
    )
  }
}
